<template>
	<div class="empty-state">
		<img
			src="../assets/undraw_no_data_re_kwbl.svg"
			alt="Aucune donnée"
			class="empty-img"
		/>
		<p class="empty-title">Aucune donnée disponible</p>
		<p class="empty-sub">
			Veuillez réessayer plus tard ou rafraîchir la page.
		</p>
	</div>
</template>

<script>
export default {};
</script>

<style scoped>
.empty-state {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 48px 16px;
	font-family: Montserrat, sans-serif;
}
.empty-img {
	width: 220px;
	opacity: 0.8;
	margin-bottom: 24px;
}
.empty-title {
	font-size: 1rem;
	font-weight: 700;
	color: #374151;
	margin: 0 0 8px;
	text-align: center;
}
.empty-sub {
	font-size: 0.78rem;
	color: #9ca3af;
	margin: 0;
	text-align: center;
}
</style>
